module.exports = __webpack_public_path__ + "img/circle-user.2fb42865.svg";